import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    content: {
        margin: "20px",
    }
});

const MainContent: React.SFC<WithStyles<"content"> & { isLandingPage: boolean; isMediaPage: boolean; }> = (props) => {
    const { classes, isLandingPage, isMediaPage } = props;
    if (isLandingPage) {
        return (
            <Grid item>
                {props.children}
            </Grid>
        );
    }
    if (isMediaPage) {
        return (
            <Grid item>
                {props.children}
            </Grid>
        );
    }
    return (
        <Grid item className={classes.content}>
            {props.children}
        </Grid>
    );
};

export default withStyles(styles)(MainContent);



// WEBPACK FOOTER //
// ./src/components/MainContent.tsx